// =============================================================================
// Hook: useSuperadminCheck
// Vérifie si l'utilisateur courant est un superadmin
// =============================================================================

import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { checkIsSuperadmin } from '@/modules/core/data/superadminRepository';

export function useSuperadminCheck() {
  const { user } = useAuth();
  const [isSuperadmin, setIsSuperadmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      if (!user) {
        setIsSuperadmin(false);
        setLoading(false);
        return;
      }

      try {
        const result = await checkIsSuperadmin();
        setIsSuperadmin(result);
      } catch (err) {
        console.error('Error:', err);
        setIsSuperadmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [user]);

  return { isSuperadmin, loading };
}
